// extracted by mini-css-extract-plugin
module.exports = {"introContent":"ArchiveBlockExtension_introContent__tEm0a"};
module.exports.__checksum = "ca7c2b9697bc"
